module.exports = __webpack_public_path__ + "static/main_2-2a3179a87393a6358786487641ac9b97.jpg";